import AccessibilityFormComponent
    from '@/components/neta/neta-event/basic-data/forms/accessibility-form/AccessibilityFormComponent.vue';

import PaymentReservationFormComponent
    from '@/components/neta/neta-event/basic-data/forms/payment-reservation-form/PaymentReservationFormComponent.vue';

import DescriptionFormComponent from '@/components/neta/neta-event/basic-data/forms/description-form/DescriptionFormComponent.vue';

import AttractionDataFormComponent
    from '@/components/neta/neta-event/basic-data/forms/attraction-data-form/AttractionDataFormComponent.vue';

import TekaComponent from "@/components/neta/neta-event/basic-data/forms/teka/TekaComponent";

let usedComponents = [
    AttractionDataFormComponent,
    DescriptionFormComponent,
    AccessibilityFormComponent,
    PaymentReservationFormComponent,
    TekaComponent
];

const routePrefix = 'neta-basic-event';

export default {
    routePrefix,
    usedComponents
};